import React from 'react'

export default ({ text }) => {
  // Hyphenation for dummies
  // TODO: We might want to make this some sort of list in Sanity
  text = text.replace('vaksine', '&shy;vaksine')
  text = text.replace('forandringer', '&shy;forandringer')
  text = text.replace('Menstruasjons', 'Menstruasjons&shy;')
  text = text.replace('Dine valg', 'Dine&nbsp;valg')

  return (
    <span dangerouslySetInnerHTML={{__html: text}}></span>
  )
}
